'use client'
import React from 'react'

const Video = ({ height = '300', width = '1000', url, title, isMobile = false }) => {
    return (
        // <div className=''>
        <iframe
            width={isMobile ? '400' : width}
            height={isMobile ? '280' : height}
            src={url}
            title="Video"
            allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen={true}>

        </iframe>
        // </div>
    )
}

export default Video